import { useCallback, useRef } from 'react';

import { useDroppable } from '@dnd-kit/core';

export const useOrdersRecognition = () => {
    const { setNodeRef, isOver } = useDroppable({
        id: 'orders-recognition-sidebar',
        data: { type: 'sidebar' },
    });

    const sidebarRef = useRef<HTMLDivElement | null>(null);

    const setSidebarRef = useCallback(
        (node: HTMLDivElement | null) => {
            sidebarRef.current = node;
            setNodeRef(node);
        },
        [setNodeRef]
    );

    return {
        sidebarRef,
        setSidebarRef,
    };
};
